import React from 'react';
import { PropTypes } from 'prop-types';
import { Divider } from '@mantine/core';
import RecordPaymentPriceItem from './RecordPaymentPriceItem';
import AppText from '../../common/AppText';
import AppStack from '../../common/AppStack';

const RefundTransactionOverview = ({
  transactionTotal,
  serviceFee,
  amountRefunded,
  currency,
  unlockRefundAmount,
  isInvoicePayment,
  installmentsScheduled
}) => {
  const refundableBalance =
    transactionTotal - amountRefunded - (unlockRefundAmount ? 0 : serviceFee);

  return (
    <AppStack style={{ flex: 1, gap: 5, alignSelf: 'stretch' }}>
      <AppText style={{ color: 'dodgerblue', fontSize: 18 }} weight={700}>
        Overview
      </AppText>
      <Divider size={2} />

      <RecordPaymentPriceItem
        currency={currency}
        isDividerHidden
        label={isInvoicePayment ? 'Invoice Cost' : 'Registration Cost'}
        value={transactionTotal}
        weight={500}
      />

      {serviceFee > 0 && (
        <RecordPaymentPriceItem
          color="#FA5252"
          currency={currency}
          isDividerHidden
          label="Service Fee"
          labelColor="#666"
          strikethrough={unlockRefundAmount}
          value={serviceFee * -1}
        />
      )}

      {amountRefunded > 0 && (
        <RecordPaymentPriceItem
          color="#FA5252"
          currency={currency}
          isDividerHidden
          label="Amount Refunded"
          labelColor="#666"
          value={amountRefunded * -1}
        />
      )}

      <Divider />

      <RecordPaymentPriceItem
        currency={currency}
        isDividerHidden={installmentsScheduled === 0}
        label="Refundable Balance"
        value={refundableBalance}
        weight={500}
      />

      {installmentsScheduled > 0 && (
        <>
          <RecordPaymentPriceItem
            color="dodgerblue"
            currency={currency}
            label="Scheduled amount"
            labelColor="dodgerblue"
            value={installmentsScheduled}
          />

          <RecordPaymentPriceItem
            currency={currency}
            isDividerHidden
            label="Refund to customer"
            value={Math.max(0, refundableBalance - installmentsScheduled)}
            weight={500}
          />
        </>
      )}
    </AppStack>
  );
};

RefundTransactionOverview.propTypes = {
  amountRefunded: PropTypes.number,
  currency: PropTypes.string,
  installmentsScheduled: PropTypes.number,
  isInvoicePayment: PropTypes.bool,
  serviceFee: PropTypes.number,
  transactionTotal: PropTypes.number,
  unlockRefundAmount: PropTypes.bool
};

export default RefundTransactionOverview;
